import { inject, Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { subjectsComplete } from 'src/app/common/app.helpers';
import { Coords } from '../../../../../swagger-api';
import { PreparedLocation, parseGeocoderResponse } from './geocoding.helper';
import { GeocodingLocationProvider } from './geocoding-location-provider/geocoding-location.provider';

@Injectable({ providedIn: 'root' })
export class GeocodingService implements OnDestroy {
  private locationByCoordsGeocoded$: Subject<PreparedLocation> = new Subject();
  private locationInputValueUpdated$: Subject<void> = new Subject();
  private provider: GeocodingLocationProvider = inject(GeocodingLocationProvider);

  public get locationByCoordsGeocoded(): Observable<PreparedLocation> {
    return this.locationByCoordsGeocoded$.asObservable();
  }

  public get locationInputValueUpdated(): Observable<void> {
    return this.locationInputValueUpdated$.asObservable();
  }

  public onLocationInputValueUpdated(): void {
    this.locationInputValueUpdated$.next();
  }

  public ngOnDestroy(): void {
    subjectsComplete([this.locationByCoordsGeocoded$]);
  }

  public geocodeLocationByCoords(coords: Coords): void {
    void this.provider.geocode(
      { location: { lat: coords.lat, lng: coords.lon } },
      (results: google.maps.GeocoderResult[], status: google.maps.GeocoderStatus) => {
        if (status === 'OK') {
          this.locationByCoordsGeocoded$.next(
            parseGeocoderResponse({
              address_components: results[0].address_components,
              location: results[0].geometry.location,
              viewport: results[0].geometry.viewport,
              street: undefined, // note: we don't use street in user location geocoding
            }),
          );
        } else {
          throw new Error('Geocoder request failed');
        }
      },
    );
  }
}
